<template>
  <div class="loading-page bg-opacity" :style="{display:hide?'none':'block'}">
    <div class="dark" @dblclick="close">
      <div class="la-ball-spin-clockwise la-2x">
        <img class="overall-situation-loading" src="~assets/images/overall-situation-loading.png">
        <div class="loading-tips">加载中...</div>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    data() {
      return {
        hide: true
      }
    },
    methods: {
      close() {
        document.querySelector('.loading-page').style.display = 'none';
      }
    }
  }
</script>

 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .show {
    display: block;
  }
 
  .hide {
    display: none;
  }
 
  .loading-page {
    background: rgba(0, 0, 0, .65);
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 100%;
    min-width: 100%;
    transition: all 1s;
    z-index: 20000;
    &.hide {
      display: none;
    }
    &.bg-opacity {
      background: rgba(255,255,255,0.4);
    }
    .dark {
      // background: rgba(255,255,255,0.4);
      width: 100px;
      height: 100px;
      border-radius: 10px;
      position: absolute;
      top: 40%;
      left: 50%;
      margin-left: -50px;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .la-ball-spin-clockwise {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .overall-situation-loading{
    width: 40px;
    height: 40px;
    animation: ball-spin-clockwise 1s infinite ease-in-out;
  }
  .loading-tips {
    width: 70px;
    font-size: 14px;
    font-family: 'PingFang SC-Regular, PingFang SC';
    font-weight: 400;
    color: #2E68EA;
  }
  @-webkit-keyframes ball-spin-clockwise{
    to {
      transform: rotate(360deg);
    }
  }
  @-moz-keyframes ball-spin-clockwise{
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes ball-spin-clockwise{
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes ball-spin-clockwise{
    to {
      transform: rotate(360deg);
    }
  }
</style>